import { render } from "./specialDetail.vue?vue&type=template&id=6344411d&scoped=true"
import script from "./specialDetail.vue?vue&type=script&lang=js"
export * from "./specialDetail.vue?vue&type=script&lang=js"

import "./specialDetail.vue?vue&type=style&index=0&id=6344411d&scoped=true&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6344411d"]])

export default __exports__